import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ProductionProcessProduct } from 'src/app/models/production-process';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { WarehouseProcessDetail } from '../execution-production-process.component';
import { InventoryService } from 'src/app/services/inventory.service';
import { ProductService } from 'src/app/services/product.service';
import { InvoiceSaleService } from '../../../sales/invoice-sale/invoice-sale.service';

@Component({
  selector: 'app-process-warehouse',
  templateUrl: './process-warehouse.component.html',
  styleUrls: ['./process-warehouse.component.scss']
})
export class ProcessWarehouseComponent implements OnInit {
  @Input() productId: number;
  @Input() warehouseId: number;
  @Input() principal: boolean = false;
  @Input() isTemp: boolean = false;
  @Input() isOut: boolean = false;
  @Input() detail: WarehouseProcessDetail = null;
  @Input() process: ProductionProcessProduct = null;

  warehouses: WarehouseResponse[] = [];
  filterWarehouses: WarehouseResponse[] = [];
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  timeout = null;
  loadingExistence = false;

  constructor(
    private warehouseService: WarehouseService,
    private inventoryService: InventoryService,
    private productService: ProductService,
    private invoiceSaleService: InvoiceSaleService
  ) { }

  ngOnInit(): void {
    this.getWarehouses("");
  }

  getWarehouses(clue) {
    this.warehouseService.getWarehouseByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses;
        if (this.filterWarehouses.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouses.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouses[0].name, true, null, 'fa-circle-check', this.filterWarehouses[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
      }
    });
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  writeWarehouse(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.warehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehouses(inputValue);
    }, 500);
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
    this.setDetail();
  }

  setDetail() {
    if (this.detail == null) {
      return;
    }
    this.detail.warehouseId = this.inputs.warehouse.data.id;
    this.detail.data = this.inputs.warehouse.data;
    this.detail.quantity = 0;

    if (!this.isOut) {
      this.invoiceSaleService.getExistence(this.detail.warehouseId, this.productId).subscribe({
        next: (response: ResponseObject) => {
          this.detail.existences = response.data;
          if (this.warehouseId == this.detail.warehouseId) {
            if (this.process!= null) {
              if (this.process.quantity > this.detail.existences) {
                this.detail.quantity = response.data;
              } else {
                this.detail.quantity = this.process.quantity;
              }
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.detail.existences = 0;
        }
      });
    }
  }
}
